import { QualityRecoveryEnum } from "requests";

export const QUALITY_OF_RECOVERY_OPTIONS = [
  { value: QualityRecoveryEnum.Poor, label: "Poor" },
  { value: QualityRecoveryEnum.Fair, label: "Fair" },
  { value: QualityRecoveryEnum.Excellent, label: "Excellent" },
  { value: QualityRecoveryEnum.Dysphoric, label: "Dysphoric" },
  { value: QualityRecoveryEnum.Slow, label: "Slow" }
];
